import { IDeleteOutputDto } from './delete-output-dto.interface';
import { ITagOutputDto } from './tags-output-dto.interface';

export interface ICarrierOutputDto extends IDeleteOutputDto {
    id: string;
    organizationId?: string;
    externalId?: string;
    name: string;
    code: string;
    businessName: string;
    address?: string;
    vatNumber?: string;
    influenceZone?: string;
    locations?: string[];
    tags?: string[] | ITagOutputDto[];
    phoneNumber?: string;
    email?: string;
    country?: string;
    createdAt?: string;
    updatedAt?: string;
    externalOrganizationId?: string;
}
